<template>
  <b-modal
    v-model="modal"
    class="position-relative"
    lazy
    centered
    body-class="py-5"
    content-class="new-section-modal"
    size="lg"
    hide-footer
    hide-header
  >
    <h3 class="text-center font-weight-bold mb-12 px-0">
      {{ folder ? 'Edit' : 'Create New' }} Folder
    </h3>

    <b-row>
      <b-col
        offset="2"
        cols="8"
      >
        <b-form @submit.prevent="submit">
          <b-form-group
            class="estage-form-group"
            label="Enter Folder Name"
          >
            <b-input
              v-model="name"
              v-validate="'required'"
              name="name"
              :state="errors.has('name') ? false : null"
            />
          </b-form-group>

          <div class="text-center mt-5">
            <b-btn
              type="submit"
              variant="primary"
              class="font-weight-bold font-size-14 px-5"
              :disabled="loading"
            >
              {{ folder ? 'Update' : 'Create' }}
              <b-spinner
                v-if="loading"
                class="ml-2 mt-1"
                variant="light"
                small
              />
            </b-btn>
          </div>
        </b-form>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'FavoriteFolderModal',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    folder: {
      type: [Object, null],
      required: false,
      default: null
    }
  },
  data () {
    return {
      name: '',
      loading: false
    }
  },
  computed: {
    ...mapState('projects', {
      project: state => state.project
    }),
    modal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    modal (val) {
      if (val) {
        if (this.folder) {
          this.name = this.folder.name
        } else {
          this.name = ''
        }
        this.loading = false
      }
    }
  },
  methods: {
    async submit () {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.loading = true

          if (this.folder) {
            await axios.put(`api/projects/${this.project.id}/favorite-blocks/categories/${this.folder.id}`, {
              name: this.name
            })
              .then(() => {
                this.$emit('success')
                this.modal = false

                this.$swal({
                  icon: 'success',
                  title: 'Success!',
                  text: 'The folder has been successfully updated',
                  showConfirmButton: false,
                  timer: 1500
                })
              })
              .catch(() => {
                this.$swal({
                  icon: 'error',
                  title: 'Server error',
                  text: 'Please try again later or let us know about your problem.',
                  showConfirmButton: false,
                  timer: 1500
                })
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            await axios.post(`api/projects/${this.project.id}/favorite-blocks/categories`, {
              name: this.name
            })
              .then(() => {
                this.$emit('success')
                this.modal = false

                this.$swal({
                  icon: 'success',
                  title: 'Success!',
                  text: 'The folder has been successfully created',
                  showConfirmButton: false,
                  timer: 1500
                })
              })
              .catch(() => {
                this.$swal({
                  icon: 'error',
                  title: 'Server error',
                  text: 'Please try again later or let us know about your problem.',
                  showConfirmButton: false,
                  timer: 1500
                })
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    }
  }
}
</script>
